import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learnerBadgeRes;
export const learnerBadgeTodo = createAsyncThunk('learnerBadge', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/get_user_badges',
            data: {
                "user_id": val,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learnerBadgeRes = res.data
    } catch (error) {
        return learnerBadgeRes = error.response.data
    }
})


const learnerBadgeSlice = createSlice({
    name: 'learnerBadge',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(learnerBadgeTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('learnerBadge', state.data)
            }
        });
        builder.addCase(learnerBadgeTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default learnerBadgeSlice.reducer; 